import * as React from 'react';
import { Header } from '@weddingspot/ws-core-components';

/**
 * Header variant for Venue Profile
 */
export const HeaderVenueProfile = () => {
    return <Header isSticky={true} showShoppingCart={false} locationsMenuTrackingSource='Profile' />;
};
